(function () {
  const root = document.querySelector('.sticky-atc');
  if (!root) return;

  const trigger = document.querySelector('[data-sticky-atc-trigger]');
  const footer = document.querySelector('.footer');

  let pastButton = false;
  let footerVisible = false;

  const updateVisibility = () => {
    root.classList.toggle('sticky-atc--visible', pastButton && !footerVisible);
  };

  root.hidden = false;

  if (trigger) {
    // The root is stretched far below the viewport, so the button counts as
    // "intersecting" anywhere below the viewport top and the observer fires
    // exactly when it scrolls off the top. With a plain viewport root, a jump
    // straight past a below-the-fold button (anchor link, fast fling) never
    // changed its state, so the bar didn't appear.
    new IntersectionObserver(
      (entries) => {
        const entry = entries[0];
        pastButton = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        updateVisibility();
      },
      { threshold: 0, rootMargin: '0px 0px 100000px 0px' }
    ).observe(trigger);
  }

  if (footer) {
    new IntersectionObserver(
      (entries) => {
        footerVisible = entries[0].isIntersecting;
        updateVisibility();
      },
      { threshold: 0 }
    ).observe(footer);
  }

  const productInfo = document.querySelector('product-info');
  const sectionId = productInfo?.dataset.section;

  // Every press scrolls to the top of the page, where the shopper chooses
  // options. Products with options add nothing from here (data-sticky-atc-top);
  // single-variant products are also added to the cart, which opens the cart
  // drawer — exactly what the main button adds when a Vitals volume-discount
  // tier is selected (tier quantity, free gift), otherwise 1.
  root.addEventListener(
    'click',
    (event) => {
      const button = event.target.closest('button');
      if (!button) return;
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top: 0, behavior: reduceMotion ? 'auto' : 'smooth' });

      if (button.hasAttribute('data-sticky-atc-top')) {
        // Keyboard users continue from the product's options.
        if (event.detail === 0) {
          productInfo
            ?.querySelector('variant-selects input, variant-selects select, .product-form__submit')
            ?.focus({ preventScroll: true });
        }
        return;
      }

      if (!window.vitalsTiers?.selected(productInfo)) return;
      const mainButton = document.getElementById(`ProductSubmitButton-${sectionId}`);
      if (!mainButton || mainButton.disabled) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      mainButton.click();
    },
    true
  );

  if (!sectionId || typeof subscribe !== 'function') return;

  const cardImage = root.querySelector('[data-sticky-atc-image]');
  const cardPrice = root.querySelector('[data-sticky-atc-price]');

  subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
    if (event.data.sectionId !== sectionId) return;

    const variant = event.data.variant;
    if (!variant) return;

    if (cardImage && variant.featured_image) {
      cardImage.src = variant.featured_image.src;
      cardImage.alt = variant.featured_image.alt || '';
    }

    if (cardPrice) {
      const sourcePrice = event.data.html.querySelector(`#price-${sectionId} .price`);
      if (sourcePrice) cardPrice.replaceChildren(sourcePrice.cloneNode(true));
    }
  });
})();
